"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StoresContext = React.createContext(null);
exports.default = StoresContext;
//# sourceMappingURL=StoresContext.js.map